// action creators
import {
  setExportOptions
} from 'export-selector';

// parsers
import {
  parseScriptsForExportOptions
} from 'export-selector/exportOptionsParser';

export const processScriptListForExportOptions = ({ dispatch, getState, rawList }) => {
  const exportOptions = parseScriptsForExportOptions({ getState, rawList });
  dispatch(setExportOptions(exportOptions));
  return Promise.resolve(exportOptions);
};
